type KeyName =
  | 'break'
  | 'backspace'
  | 'tab'
  | 'clear'
  | 'enter'
  | 'shift'
  | 'ctrl'
  | 'alt'
  | 'pause'
  | 'capslock'
  | 'hangul'
  | 'hanja'
  | 'escape'
  | 'conversion'
  | 'non-conversion'
  | 'spacebar'
  | 'pageUp'
  | 'pageDown'
  | 'end'
  | 'home'
  | 'arrowLeft'
  | 'arrowUp'
  | 'arrowRight'
  | 'arrowDown'
  | 'select'
  | 'print'
  | 'execute'
  | 'printScreen'
  | 'insert'
  | 'delete'
  | 'help'
  | 'a';

export const KEY_MAP = new Map<KeyName, number>([
  ['break', 3],
  ['backspace', 8],
  ['tab', 9],
  ['clear', 12],
  ['enter', 13],
  ['shift', 16],
  ['ctrl', 17],
  ['alt', 18],
  ['pause', 19],
  ['capslock', 20],
  ['hangul', 21],
  ['hanja', 25],
  ['escape', 27],
  ['conversion', 28],
  ['non-conversion', 29],
  ['spacebar', 32],
  ['pageUp', 33],
  ['pageDown', 34],
  ['end', 35],
  ['home', 36],
  ['arrowLeft', 37],
  ['arrowUp', 38],
  ['arrowRight', 39],
  ['arrowDown', 40],
  ['select', 41],
  ['print', 42],
  ['execute', 43],
  ['printScreen', 44],
  ['insert', 45],
  ['delete', 46],
  ['help', 47],
  ['a', 65]
]);

type ModifierKey = 'ctrl' | 'alt' | 'shift' | 'meta';
interface SimpleKeyboardEvent {
  keyCode: number;
  which: number;
  altKey?: boolean;
  ctrlKey?: boolean;
  shiftKey?: boolean;
  metaKey?: boolean;
}
export const Keys = {
  is(e: SimpleKeyboardEvent, expectedKey: KeyName, modifierKey?: ModifierKey) {
    return (
      (e.keyCode || e.which) === KEY_MAP.get(expectedKey) && (!modifierKey || (modifierKey && e[`${modifierKey}Key`]))
    );
  },
  isOneOf(e: SimpleKeyboardEvent, expectedKeys: KeyName[]) {
    return expectedKeys.map((k) => KEY_MAP.get(k)).includes(e.keyCode || e.which);
  },
  hasNoModifierKey(e: SimpleKeyboardEvent) {
    return !e.altKey && !e.ctrlKey && !e.shiftKey && !e.metaKey;
  },
  hasModifierKey(e: SimpleKeyboardEvent) {
    return e.altKey || e.ctrlKey || e.shiftKey || e.metaKey;
  }
};
